// Input: numbers are sellers numbers
//        amount total shares to sell
//        eventRef arbitary reference string for transaction (added to sold numbers)
// returns remaingNumbers   for the seller
//         soldNumbers      for the guy buying

import { OrgbrainErrorCodes } from '@orgbrain/lib-data';
import { ShareNumbers, ShareNumbersEventRef } from './sharenumber-classes';
import {
  cloneShareNumbers,
  cloneShareNumbersArray,
  santizeShareNumbers,
} from './transactionHelpers';

export function calculateShareNumbersToBeSold({
  numbers,
  amount,
  eventRef,
  timeStamp,
}: {
  numbers: ShareNumbers[];
  amount: number;
  eventRef: ShareNumbersEventRef;
  timeStamp: number;
}): { remainingNumbers: ShareNumbers[]; soldNumbers: ShareNumbers[] } {
  let remainingNumbers: ShareNumbers[] = cloneShareNumbersArray(numbers);

  santizeShareNumbers(remainingNumbers);
  const soldNumbers: ShareNumbers[] = [];
  while (amount > 0) {
    const number = remainingNumbers[0];
    remainingNumbers = remainingNumbers.slice(1);
    if (!number) {
      //throw { code: OrgbrainErrorCodes.NOT_ENOUGH_SHARES };
      break;
    }
    const recordAmount = number.to - number.from;
    if (amount >= recordAmount) {
      number.eventRef = eventRef;
      number.timeStamp = timeStamp;
      soldNumbers.push(number);
      amount -= number.to - number.from;
    } else {
      const soldRecord = cloneShareNumbers(number);
      remainingNumbers.push(number);
      number.from += amount;
      amount = 0;
      soldRecord.to = number.from;
      soldRecord.eventRef = eventRef;
      soldRecord.timeStamp = timeStamp;
      soldNumbers.push(soldRecord);
    }
  }

  return { remainingNumbers, soldNumbers };
}
